import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { getUser, getUserProfile } from '~/api';
import { getAuthToken } from '~/auth';
import { ProfileExpanded, User } from '~/types';

const initialState = {
  isReady: false,
  isSignedIn: false,
  user: null as User | null,
  userProfile: null as ProfileExpanded | null,
};

export const useAuth = create(
  combine(initialState, (set) => ({
    setUserProfile: (profile: ProfileExpanded) => {
      set(() => ({ userProfile: profile }));
    },

    checkSignedIn: async () => {
      try {
        const authToken = await getAuthToken();

        if (!authToken) throw new Error('No auth token');

        const [{ user }, { profile: userProfile }] = await Promise.all([
          getUser({}),
          getUserProfile({}),
        ]);
        const isSignedIn = !!(authToken && user);

        set(() => ({ isSignedIn, user, userProfile, isReady: true }));
      } catch (error) {
        set(() => ({ isSignedIn: false, user: null, isReady: true }));
      }
    },

    loadUserProfile: async () => {
      try {
        const { profile } = await getUserProfile({});

        set(() => ({ userProfile: profile }));
      } catch (error) {}
    },
  })),
);
